import "./BlogCategoryFilter.css";

const categories = [
  "All",
  "UI/UX",
  "Web Development",
  "Mobile Apps",
  "Software",
  "Game Development",
  "Technology"
];

const BlogCategoryFilter = () => {
  return (
    <section className="blog-filter-section">

      <div className="blog-filter-container">

        {categories.map((category, index) => (

          <button
            key={index}
            className={`blog-filter-button ${index === 0 ? "active" : ""}`}
          >
            {category}
          </button>

        ))}

      </div>

    </section>
  );
};

export default BlogCategoryFilter;